import useWindowDimensions from "../hooks/useWindowDimensions";

const About = () => {
  const { width } = useWindowDimensions();

  return (
    <div
      id="about"
      className="d-flex flex-column justify-content-center align-items-center text-center py-5"
      style={{
        scrollMarginTop: 60,
        backgroundImage:
          "linear-gradient(to right, rgba(var(--secondary-rgb), 0.2), rgba(var(--primary-rgb), 0.2))",
        boxShadow:
          "0 0 120px 5px rgba(var(--primary-rgb), 0.2), 0 0 120px 0px rgba(var(--secondary-rgb), 0.2)",
      }}
    >
      <div className="container" style={{ padding: width > 992 && 75 }}>
        <h1
          className="primary-h mx-auto"
          data-aos="fade-up"
          data-aos-duration="700"
        >
          About
          <br />
          The
          <br />
          Club
        </h1>
        <p
          className="primary-p my-3"
          data-aos="fade-up"
          data-aos-delay="100"
          data-aos-duration="700"
        >
          The Laser Octopus Club is a limited collection of 8,500 unique Laser
          Octopus Club NFTs - digital collectibles on the Ethereum blockchain
          based on the Laser Octopus™ brand. These powerful yet adorable
          galactic creatures are invading the Earth and getting their slimy
          tentacles on anything cool and yummy they can find!
          <br />
          <br />
          <span
            style={{
              color: "var(--primary)",
              fontWeight: 700,
              fontSize: width > 992 ? 28 : 18,
              letterSpacing: 2,
              textShadow: "0 0 30px rgba(var(--secondary-rgb), 0.75)",
            }}
          >
            Own yours today before they’re gone!
          </span>
        </p>
        <br />
        <br />
        <h1
          className="primary-h"
          data-aos="fade-up"
          data-aos-delay="200"
          data-aos-duration="700"
        >
          75 Traits / Designed in Italy
        </h1>
        <p
          className="primary-p my-3"
          data-aos="fade-up"
          data-aos-delay="200"
          data-aos-duration="700"
        >
          The Laser Octopus Club NFTs possess unique traits that stand out from
          other projects in the form of transmutation skin patterns to include:
          ninjas, zombies, reptiles, mammals, psychedelic, cyborgs, thermal
          vision, galaxy, fiction, legacy design & more. Other traits include
          varied lasers, colorful drips, fun weapons, heist loots, yummy food,
          earrings, candy, random cool items and gadgets.
        </p>
      </div>
    </div>
  );
};

export default About;
